// "Vistos recientemente" en el carrito vacío: reutiliza el mismo historial
// de navegación que ya guarda el buscador del header (sections/ss-header-14.liquid)
// en localStorage bajo la clave "iamassa_recently_viewed" -no crea un
// mecanismo de tracking nuevo, solo lo lee-.
//
// Si hay historial, se muestran hasta 2 productos vistos y se oculta el
// bloque de "Más vendidos" (ya renderizado en el servidor, ver
// snippets/cart-drawer.liquid) para no duplicar recomendaciones.
// Si no hay historial, no se toca nada: el bloque de "Más vendidos" se
// queda visible tal cual vino del servidor.
(function () {
  var RV_KEY = 'iamassa_recently_viewed';

  function esc(value) {
    return String(value == null ? '' : value).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function getRecentlyViewed() {
    try {
      var items = JSON.parse(localStorage.getItem(RV_KEY) || '[]');
      return Array.isArray(items) ? items : [];
    } catch (e) {
      return [];
    }
  }

  function cardHTML(item) {
    var imgTag = item.image
      ? '<img src="' + esc(item.image) + '" alt="' + esc(item.title) + '" loading="lazy" width="300" height="300">'
      : '';
    return (
      '<a href="' + esc(item.url) + '" class="cart-drawer__upsell-card">' +
      imgTag +
      '<div><p class="cart-drawer__upsell-card-title">' + esc(item.title) + '</p>' +
      '<p class="cart-drawer__upsell-card-price">' + esc(item.price) + '</p></div>' +
      '</a>'
    );
  }

  function render() {
    var recentBlock = document.getElementById('CartDrawer-RecentlyViewed');
    var recentGrid = document.getElementById('CartDrawer-RecentlyViewed-Grid');
    if (!recentBlock || !recentGrid) return;

    var items = getRecentlyViewed();
    if (!items.length) return;

    var bestsellersBlock = document.getElementById('CartDrawer-Bestsellers');

    recentGrid.innerHTML = items.slice(0, 2).map(cardHTML).join('');
    recentBlock.hidden = false;
    if (bestsellersBlock) bestsellersBlock.hidden = true;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', render);
  } else {
    render();
  }
})();
